import type {
	SRT_ColumnDef,
	SRT_PaginationState,
	SRT_TableOptions,
} from '@/shared/components/master-table'
import type { Updater } from '@tanstack/react-table'
import type { ScenarioRunSetRow } from '../model/types'

import { useMasterReactTable } from '@/shared/components/master-table'
import { getMasterTableLocale } from '@/shared/i18n'

export function useWhatifRunsTable({
	columns,
	data,
	isLoading,
	pagination,
	rowCount,
	onPaginationChange,
	renderRowActionMenuItems,
}: {
	rowCount: number
	columns: SRT_ColumnDef<ScenarioRunSetRow>[]
	data: ScenarioRunSetRow[]
	isLoading: boolean
	pagination: SRT_PaginationState
	onPaginationChange: (updaterOrValue: Updater<SRT_PaginationState>) => void
	renderRowActionMenuItems: NonNullable<
		SRT_TableOptions<ScenarioRunSetRow>['renderRowActionMenuItems']
	>
}) {
	return useMasterReactTable({
		localization: getMasterTableLocale(),
		columns,
		data,
		rowCount,
		state: {
			isLoading,
			columnVisibility: {
				scenarios: false,
				optimization_groups: false,
			},

			pagination,
		},
		defaultColumn: {
			minSize: 28,
			size: Number.MAX_SAFE_INTEGER,
			maxSize: Number.MAX_SAFE_INTEGER,
		},
		displayColumnDefOptions: {
			'srt-row-actions': {
				header: '',
			},
		},
		renderRowActionMenuItems,
		enableRowActions: true,
		positionActionsColumn: 'last',
		layoutMode: 'grid',
		enableColumnActions: false,
		manualFiltering: true,
		manualPagination: true,
		enableVirtualization: true,
		enableTableHead: false,
		getRowHeight: (row) => 68,
		defaultRowHeight: 68,
		divideX: false,
		onPaginationChange,
	})
}
